<h1 class="margin-bottom">WE talk</h1>
<app-notification class="margin-bottom" color="#FFA135"
                  [title]="'home.welcomePage.heroTitle' | translate">
  <i>{{ 'home.welcomePage.heroQuote' | translate }}</i>
</app-notification>

 <div class="iframe-container margin-top-xl">
  <youtube-player [playerVars]="playerVars" disableCookies="true"  [videoId]="videoLinks[role]" />
 </div>

<div class="margin-top-xl margin-bottom">
  <strong class="text-secondary cooper text-large">{{ 'home.welcomePage.hello' | translate:{ role: roleLabel } }}</strong>
</div>
<div class="margin-top-xl margin-bottom">
  <strong class="text-primary">{{ 'home.welcomePage.objective' | translate }}</strong>
</div>
<div *ngIf="role === Role.Talker">
  <div>{{ 'home.welcomePage.talkerP1' | translate }}</div>
  <div class="margin-top-xl margin-bottom">
    <strong class="text-primary">{{ 'home.welcomePage.howItWorks' | translate }}</strong>
  </div>
  <div>{{ 'home.welcomePage.talkerHow' | translate }}
    <ul class="margin-top margin-bottom">
      <li>{{ 'home.welcomePage.talkerSpeech' | translate }}</li>
      <li>{{ 'home.welcomePage.talkerCoaching' | translate }}</li>
    </ul>
    {{ 'home.welcomePage.talkerCoach' | translate }}
  </div>


  <div class="margin-top-xl margin-bottom">
    <strong class="text-primary">{{ 'home.welcomePage.extras' | translate }}</strong>
  </div>
  <div>{{ 'home.welcomePage.talkerExtras' | translate }}</div>
</div>

<div *ngIf="role === 'pilot'" class="column gap">
  <div>{{ 'home.welcomePage.pilotP1' | translate }}</div>
  <div>{{ 'home.welcomePage.pilotP2' | translate }}</div>
  <div>{{ 'home.welcomePage.pilotP3' | translate }}</div>
</div>
<div *ngIf="role === Role.Sherpa" class="column gap">
  <div>{{ 'home.welcomePage.sherpaP1' | translate }}</div>
  <div>{{ 'home.welcomePage.sherpaP2' | translate }}</div>
  <div>{{ 'home.welcomePage.sherpaP3' | translate }}</div>
  <div>{{ 'home.welcomePage.sherpaP4' | translate }}</div>
</div>
<div class="margin-top-xl margin-bottom" *ngIf="role !== Role.Talker">
  <strong class="text-primary">{{ 'home.welcomePage.pride' | translate }}</strong>
</div>
<div>{{ 'home.welcomePage.prideBody' | translate }}</div>
